export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCoQbZxNWNnMSZUOtze7dqjBiP3p9LDgdQ',
    authDomain: 'sampleliste.firebaseapp.com',
    databaseURL: 'https://sampleliste.firebaseio.com',
    projectId: 'sampleliste',
    storageBucket: 'sampleliste.appspot.com',
    messagingSenderId: '245087423467',
    appId: '1:245087423467:web:9579a948c2b4e6a908a7ae',
  },
  amplitude: {
    apiKey: 'a96483776be7dde0c0b13ae372c2ee85',
  },
};
